/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingcustomizeperplatform3Inputs */

const en_crosspostingcustomizeperplatform3 = /** @type {(inputs: Crosspostingcustomizeperplatform3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customize caption per platform`)
};

const de_crosspostingcustomizeperplatform3 = /** @type {(inputs: Crosspostingcustomizeperplatform3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildunterschrift pro Plattform anpassen`)
};

/**
* | output |
* | --- |
* | "Customize caption per platform" |
*
* @param {Crosspostingcustomizeperplatform3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingcustomizeperplatform3 = /** @type {((inputs?: Crosspostingcustomizeperplatform3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingcustomizeperplatform3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingcustomizeperplatform3(inputs)
	return de_crosspostingcustomizeperplatform3(inputs)
});
export { crosspostingcustomizeperplatform3 as "crosspostingCustomizePerPlatform" }